export default __webpack_public_path__ + "static/media/john-towner.34a9a271.jpg";